/**
 * Normalizes phone numbers for calling/dialing:
 * - Converts Devanagari numerals (०-९) to ASCII digits (0-9)
 * - Retains leading '+' if present
 * - Strips spaces, hyphens, and non-digit characters
 * - Returns empty string if no digits are present (preventing 'tel:+')
 */
export function normalizePhone(value) {
  if (!value) return '';
  const str = String(value).trim();
  const ascii = str.replace(/[०-९]/g, digit => '०१२३४५६७८९'.indexOf(digit));
  const digits = ascii.replace(/\D/g, '');
  if (!digits) return '';
  const hasPlus = ascii.startsWith('+');
  return hasPlus ? `+${digits}` : digits;
}

/**
 * Returns a safe tel: href string or undefined if no valid digits exist
 */
export function phoneHref(value) {
  const norm = normalizePhone(value);
  return norm ? `tel:${norm}` : undefined;
}

export default {
  normalizePhone,
  phoneHref,
};
